import { render, staticRenderFns } from "./episode-list.vue?vue&type=template&id=20bcab64&scoped=true&"
import script from "./episode-list.vue?vue&type=script&lang=js&"
export * from "./episode-list.vue?vue&type=script&lang=js&"
import style0 from "./episode-list.vue?vue&type=style&index=0&id=20bcab64&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bcab64",
  null
  
)

export default component.exports